import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SessionApiRepository } from '../repositories/session-api.repository';
import { SessionInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class SessionProvider {
    constructor(private sessionApiRepository: SessionApiRepository) {}

    current(): Observable<Transaction<SessionInterface>> {
        return this.sessionApiRepository.load();
    }

    update(token: string): Observable<Transaction<void>> {
        return this.sessionApiRepository.update(token);
    }
}
